import { gql } from '../../../apollo/__generated__';

export const CREATE_TARGET = gql(`
  mutation CreateTarget($createTargetInput: CreateTargetInput!) {
    createTarget(createTargetInput: $createTargetInput) {
      id
    }
  }
`);
